export const MULTI_VALUE = 'Multiple-values';

// asset constants key
export const AssetMetadata = {
  General: {
    TAGS: 'tags',
    OTHER: 'other',
    MEDIA: 'media',
    BRAND: 'brand',
    CLIENT: 'client',
    DOMAINS: 'domains',
  },
  Product: {
    PRODUCT: 'product',
    CATEGORY: 'category',
    SUBCATEGORY: 'subcategory',
    BRAND_MODEL: 'brandModel',
  },
  Rights: {
    NO_EXPIRY: 'noExpiry',
    EXPIRY_DATE: 'expiryDate',
    USAGE_RIGHTS: 'usageRights',
    USAGE_RIGHTS_GENERAL_INFORMATION: 'usageRightsGeneralInformation',
    ASSET_USAGE_RIGHT: 'assetUsageRight',
    BUYOUT_RIGHTS: 'buyoutRights',
    BUYOUT_RIGHTS_TITLE: 'buyoutRightsTitle',
    BUYOUT_RIGHTS_FORM_ARRAY: 'buyoutRightsFormArray',
    BUYOUT_RIGHTS_SECOND_LEVEL_TYPE: 'buyoutRightsSecondLevelType',
  },
  Collections: {
    COLLECTION: 'collection',
    CREATE_NEW: 'createNewCollectionMetadata',
    ADD_TO_EXISTING: 'addToExistingCollectionMetadata',
  },
  Form: {
    FORM_ARRAY: 'formArray',
    FORM_FIELD_NAME: 'formFieldName',
    TERRITORIES_FORM_ARRAY: 'territoriesFormArray',
  },
  Others: {
    KEYWORDS: 'keywords',
    TERRITORY: 'territory',
    DUPLICATE: 'duplicate',
    TERRITORIES: 'territories',
    SELECT_TYPE: 'selectType',
    IMAGE_SOURCE: 'imageSource',
    STEPPER_MODEL: 'stepperModel',
    CREATOR_DEPARTMENT: 'creatorDepartment',
    ADDITIONAL_INFORMATION: 'additionalInformation',
  },
};

export const AssetGridView = {
  GridView: {
    SHOW_GRID_VIEW_SMALL: 'showGridViewSmall',
    SHOW_GRID_VIEW_SIDEBAR: 'showGridViewSidebar',
    SHOW_GRID_VIEW_LARGE: 'showGridViewLarge',
    SHOW_LIST_VIEW: 'showListView',
  },
};
